import { gql } from '@apollo/client/core';

export const UPSERT_PROFILE_SITTER = gql`
  mutation Upsert($profile: ProfileInput!) {
    profile {
      upsert(profile: $profile) {
        id
        location {
          zipcode
        }
      }
    }
  }
`;

export const UPSERT_EMPTY_PROFILE_SITTER = gql`
  mutation UpsertEmptyProfile {
    profile {
      upsertEmpty {
        id
      }
    }
  }
`;
